import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import SiteHeader from '../components/SiteHeader';
import SiteFooter from '../components/SiteFooter';

export const ContactPage = () => {
  return (
    <div className="landing-page" data-testid="contact-page">
      <SiteHeader />

      <section className="page-content-section">
        <div className="container page-container-inner">
          <h1 className="page-main-title" data-testid="contact-title">Contact Us</h1>
          <p className="page-subtitle">We'd love to hear from you. Whether you have questions, feedback, or need support, we're here to help.</p>

          <div className="contact-grid">
            <Card className="feature-card" data-testid="contact-support-card">
              <CardContent className="feature-content">
                <h3 className="feature-title">Support</h3>
                <p className="feature-description">
                  <a href="mailto:support@bucktime.ca">support@bucktime.ca</a>
                </p>
              </CardContent>
            </Card>

            <Card className="feature-card" data-testid="contact-feedback-card">
              <CardContent className="feature-content">
                <h3 className="feature-title">Feedback</h3>
                <p className="feature-description">
                  <a href="mailto:feedback@bucktime.ca">feedback@bucktime.ca</a>
                </p>
              </CardContent>
            </Card>

            <Card className="feature-card" data-testid="contact-privacy-card">
              <CardContent className="feature-content">
                <h3 className="feature-title">Privacy</h3>
                <p className="feature-description">
                  <a href="mailto:privacy@bucktime.ca">privacy@bucktime.ca</a>
                </p>
              </CardContent>
            </Card>

            <Card className="feature-card" data-testid="contact-location-card">
              <CardContent className="feature-content">
                <h3 className="feature-title">Company</h3>
                <p className="feature-description">
                  BuckTime! Inc.<br />
                  Ontario, Canada
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
};

export default ContactPage;
